// What's on, fetched once and read by two surfaces: the poster wall in
// the world and the panel on the N key.
//
// Core, not render: the boundary in CLAUDE.md says game/net/state logic
// never imports Three.js, and the wall is a *renderer* of this data, not
// the owner of it. Core already does HTTP (core/net.ts).

import type { NightBill } from "@bebop/shared";

/** The public bill. Unauthenticated on purpose — see GET /api/nights. */
export async function fetchNights(): Promise<NightBill[]> {
  const res = await fetch("/api/nights");
  if (!res.ok) throw new Error(String(res.status));
  const body = (await res.json()) as { nights: NightBill[] };
  return body.nights;
}
